import "./timezone-pane.styl"
import template from "./timezone-pane.pug"
import { PopupPane } from "@/lib/components/popup/popup-pane"
import { ObservableData } from "@/lib/utils/observable-data"
import { TIME_ZONES_MAP } from "@/lib/utils/timezones"

export class TimezonePane extends PopupPane
   constructor: (selectedTimezone) ->
      assertArgs(arguments, Function)
      assertOfType(selectedTimezone, optional(Object))
      super(template())
      @title = ko.observable()
      @leftActionBtn = ko.observable({
         text: "Cancel"
         callback: @cancelPopup
      })
      @rightActionBtn = ko.observable({
         text: "Select"
         callback: @saveTimezone
      })

      # Popup Properties
      @zoneName = ko.observable()
      @selectedTimezone = selectedTimezone
      @zoneName(@selectedTimezone()) if @selectedTimezone()?
      seen = {}
      @timezoneOptions = ko.observableArray()
      addTimezoneOption = (iana, displayName) =>
         return if not iana or seen[iana]
         seen[iana] = true
         @timezoneOptions.push({value: iana, label: displayName or iana})

      for displayName, iana of TIME_ZONES_MAP
         addTimezoneOption(iana, displayName)

      # The map can select zones TIME_ZONES_MAP does not cover. The select must be
      # able to represent whatever is selected, otherwise Knockout's value binding
      # rejects the zone and writes the empty caption back over it.
      addTimezoneOption(@zoneName())
      @zoneName.subscribe(addTimezoneOption)

   handleSelection: (name, offset, abbreviation) =>
      @zoneName(name)

   cancelPopup: ->
      @dismissHandler()

   saveTimezone: =>
      @selectedTimezone(@zoneName())
      @dismissHandler()
